import {
  LatLng,
  PlantationType,
  Recommendations as RecommendationsUi,
} from '../../components';
import React from 'react';

import { useCurrentLocation } from '../../providers/CurrentLocationProvider/CurrentLocationProvider';

import { useRecommendation } from './useRecommendations';

const Recommendations = () => {
  const { latLng, setLatLng } = useCurrentLocation();

  const [plantationType, setPlantationType] =
    React.useState<PlantationType>('iLPF');

  const handleOnLatLng = React.useCallback(
    (value: LatLng) => {
      setLatLng(value);
    },
    [setLatLng]
  );

  const { recommendationsChartsProps, recommendations } = useRecommendation({
    latLng,
    plantationType,
  });

  return (
    <RecommendationsUi
      initialLocation={latLng}
      onChangePlantationType={setPlantationType}
      onLatLng={handleOnLatLng}
      recommendations={recommendations}
      recommendationsChartsProps={recommendationsChartsProps}
    />
  );
};

export default Recommendations;
